/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_CreateInputs */

const vi_pl_pnk_create = /** @type {(inputs: Pl_Pnk_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo PNK`)
};

/**

* @param {Pl_Pnk_CreateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_create = /** @type {((inputs?: Pl_Pnk_CreateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_CreateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_create(inputs)
});